import * as React from 'react';
import { LoadOptions } from '..';
import { keyCode } from '../key-code-types';

interface KeyboardSupportComponentProps {
  inputValue: string;
  closeOptions: () => void;
  loadAndOpenOptions: (loadOptions: LoadOptions) => void;
  children?: React.ReactNode;
}

class KeyboardSupportComponent extends React.Component<KeyboardSupportComponentProps> {
  private handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    switch (e.keyCode) {
      case keyCode.Esc:
        this.props.closeOptions();
        break;
      case keyCode.ArrowDown:
        this.props.loadAndOpenOptions({ query: this.props.inputValue });
        break;
      default:
        break;
    }
  };

  public render(): JSX.Element {
    return (<div tabIndex={-1} onKeyDown={this.handleKeyDown}>
      {this.props.children}
    </div>);
  }
}

export const KeyboardSupport = KeyboardSupportComponent;
